export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/buble-loader/index.js??ref--3-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=template&id=272d2c1f&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Badge.vue?vue&type=template&id=272d2c1f&scoped=true
// module id = 77
// module chunks = 0